import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=6cf66b64&scoped=true&"
import script from "./PortalHeader.vue?vue&type=script&lang=ts&"
export * from "./PortalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&id=6cf66b64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf66b64",
  null
  
)

export default component.exports